export const docsNavItems = [
  { title: 'Overview', path: '/docs' },
  { title: 'Getting Started', path: '/docs/getting-started' },
  { title: 'Editor', path: '/docs/editor' },
  { title: 'Collaboration', path: '/docs/collaboration' },
  { title: 'Projects', path: '/docs/projects' },
  { title: 'Execution', path: '/docs/execution' },
  { title: 'Chat', path: '/docs/chat' },
  { title: 'Git', path: '/docs/git' },
  { title: 'Roles', path: '/docs/roles' },
  { title: 'Troubleshooting', path: '/docs/troubleshooting' },
  { title: 'FAQ', path: '/docs/faq' },
];
